export default __webpack_public_path__ + "assets/media/placeholder-video.7484fc12.svg";